import { useState } from 'react';
import './css/insights.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAnglesRight, faAnglesLeft, faAngleLeft } from "@fortawesome/free-solid-svg-icons"
import { useDispatch, useSelector } from 'react-redux'

const createArr = (n) => {
    const iArr = new Array(n);
    for (var i = 0; i < n; i++)  iArr[i] = i + 1;
    return iArr;
}

function Page({ initialData, page, setPage, maxFirstPage, onContent1Click }) {

    let len = initialData.length;
    let maxPage = 0
    if (parseInt(Number(len) % maxFirstPage) === 0) {
        maxPage = parseInt(Number(len) / maxFirstPage)
    }
    else {
        maxPage = parseInt(Number(len) / maxFirstPage) + 1;
    }
    let pageLimit = Math.min(parseInt(Number(len) / maxFirstPage) + 1, 5);

    const [blockNum, setBlockNum] = useState(0);
    const [currPage, setCurrPage] = useState(1);

    const v = Number(blockNum * pageLimit);
    const iArr = createArr(maxPage);
    let pArr = iArr.slice(v, Number(pageLimit) + v);

    const firstPage = () => {
        setPage(1)
        setBlockNum(0)
        setCurrPage(1)
    }

    const lastPage = () => {
        setPage(maxPage)
        setBlockNum(Math.ceil(maxPage / pageLimit) - 1)
        setCurrPage(maxPage)
    }

    const prevPage = () => {
        setBlockNum(n => n - 1);
        setCurrPage((blockNum - 1) * pageLimit + 1);
        setPage((blockNum - 1) * pageLimit + 1);
    }
    const nextPage = () => {
        setBlockNum(n => n + 1);
        setCurrPage((blockNum + 1) * pageLimit + 1);
        setPage((blockNum + 1) * pageLimit + 1);
    }

    const nowPage = (n) => {
        setPage(n)
        setCurrPage(n)
    }

    return (
        <>
            <div className='paging'>
                <div className={`paging-pages`}>
                    {/* {
                        page <= 5
                            ?
                            ""
                            :
                            <>
                                <div className={`paging-btn`} onClick={firstPage}>
                                    <FontAwesomeIcon icon={faAnglesLeft} />
                                </div>
                                <div className={`paging-btn`} onClick={prevPage}>
                                    <FontAwesomeIcon icon={faAngleLeft} />
                                </div>
                            </>
                    } */}
                    {pArr.map(num => (
                        page == num ?
                            (<span key={num} className='active'>
                                {num}
                            </span>) :
                            (<span key={num} className='' onClick={() => {
                                { nowPage(num); onContent1Click() };
                            }}>
                                {num}
                            </span>)
                    ))}
                    {/* {
                        page === maxPage
                            ?
                            ""
                            :
                            <>
                                <div className={`paging-btn`} onClick={nextPage}>
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </div>
                                <div className={`paging-btn`} onClick={lastPage}>
                                    <FontAwesomeIcon icon={faAnglesRight} />
                                </div>
                            </>
                    } */}
                </div>
            </div>
        </>
    );
}

export default Page;